import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in document.documentElement.style ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
};

export const BackToTop = () => {
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(max > 0 ? window.scrollY / max : 0);
      setShow(window.scrollY > 600);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const r = 22, c = 2 * Math.PI * r;
  return (
    <AnimatePresence>
      {show && (
        <motion.button initial={{ opacity: 0, y: 20, scale: 0.8 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 20, scale: 0.8 }} whileHover={{ y: -3 }} whileTap={{ scale: 0.92 }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} aria-label="Volver arriba" data-testid="back-to-top"
          className="group fixed left-4 bottom-4 md:left-6 md:bottom-6 z-40 h-14 w-14 rounded-full bg-cometa-tinta text-cometa-crema shadow-2xl shadow-black/30 flex items-center justify-center">
          <svg className="absolute inset-0 -rotate-90" viewBox="0 0 56 56" aria-hidden="true">
            <circle cx="28" cy="28" r={r} stroke="rgba(251,247,240,0.15)" strokeWidth="3" fill="none" />
            <circle cx="28" cy="28" r={r} stroke="#FFBC01" strokeWidth="3" fill="none" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - progress)} style={{ transition: "stroke-dashoffset 120ms linear" }} />
          </svg>
          <ArrowUp size={20} className="relative group-hover:-translate-y-0.5 transition" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};
